import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { EPanelOpenMethod } from '@components/block-event-single/store';
import { PageJumpConfirmation } from '@components/common';
import ButtonKit from '@components/common/ButtonKit';
import AddEllipsisWithTooltip from '@components/common/EllipsisTooltip/AddEllipsisWithTooltip';
import {
  IMetricRow,
  IMetricsRelatedCard,
} from '@components/detail-panel/components/MetricsRelatedCard/typed';
import { useGetMetricById } from '@components/metrics-builder/api/queryHooks';
import { useMetricBuilderStore } from '@components/metrics-builder/store';

import { TextField } from '../EventStatusCard/styled';
import { MetricRowContainer, RelatedMetricsTitle } from './styled';

export const MetricRow: React.FC<IMetricRow> = ({ label, onClick }) => {
  return (
    <MetricRowContainer>
      <AddEllipsisWithTooltip text={label} dataIndex={'0'}>
        <TextField>{label}</TextField>
      </AddEllipsisWithTooltip>
      <ButtonKit
        kitType="primary"
        children="Detail"
        borderColor={'transparent'}
        style={{ fontWeight: 400, fontSize: '12px', padding: '5px 6px' }}
        onClick={onClick}
      />
    </MetricRowContainer>
  );
};

export const MetricsRelatedCard: React.FC<IMetricsRelatedCard> = ({
  mode,
  mappedEvent,
  onCloseDrawer,
}) => {
  const navigate = useNavigate();

  const [editMetric] = useMetricBuilderStore((state) => [state.editMetric]);

  const [metricId, setMetricId] = useState<number | undefined>(undefined);

  const { data: metric } = useGetMetricById({ id: metricId });

  const isEditMode = mode === EPanelOpenMethod.EDIT;

  useEffect(() => {
    if (metric && metricId) {
      editMetric(metric?.data);
      navigate(`/metric-builder/metric/${metricId}`);
      onCloseDrawer?.();
    }
  }, [metric, metricId]);

  const handleMetricsNameClick = (id: number) => {
    setMetricId(id);
  };

  return (
    <div>
      <RelatedMetricsTitle>Related Metrics</RelatedMetricsTitle>
      {(mappedEvent?.related_metrics ?? []).map((metric) => {
        const { id, name } = metric;
        return (
          <PageJumpConfirmation
            key={JSON.stringify(metric)}
            pageValidationEnabled={isEditMode}
            onCancel={() => handleMetricsNameClick(id)}
          >
            <MetricRow label={name} onClick={() => !isEditMode && handleMetricsNameClick(id)} />
          </PageJumpConfirmation>
        );
      })}
    </div>
  );
};
